const isEmpty = (v) => v === undefined || v === null || v === '';
const normalize = (v) => (v === undefined || v === null ? '' : String(v));

const evalClause = (clause, values) => {
  const op = String(clause?.op || 'equals').toLowerCase();
  const raw = values?.[clause?.fieldKey];
  const expected = clause?.value;
  switch (op) {
    case 'equals': return normalize(raw) === normalize(expected);
    case 'not_equals': return normalize(raw) !== normalize(expected);
    case 'contains': return normalize(raw).toLowerCase().includes(normalize(expected).toLowerCase());
    case 'not_contains': return !normalize(raw).toLowerCase().includes(normalize(expected).toLowerCase());
    case 'greater_than': return Number(raw) > Number(expected);
    case 'less_than': return Number(raw) < Number(expected);
    case 'is_empty': return isEmpty(raw);
    case 'is_not_empty': return !isEmpty(raw);
    case 'in': {
      const list = Array.isArray(expected) ? expected : String(expected || '').split(',').map((s) => s.trim());
      return list.map(normalize).includes(normalize(raw));
    }
    case 'not_in': {
      const list = Array.isArray(expected) ? expected : String(expected || '').split(',').map((s) => s.trim());
      return !list.map(normalize).includes(normalize(raw));
    }
    case 'boolean_true': return raw === true || raw === 'true' || raw === 1 || raw === '1';
    case 'boolean_false': return raw === false || raw === 'false' || raw === 0 || raw === '0' || isEmpty(raw);
    default: return false;
  }
};

export const evaluateConfigRules = (rules, values = {}) => {
  const effects = {};
  const ensure = (key) => {
    if (!effects[key]) effects[key] = {};
    return effects[key];
  };
  for (const rule of (rules || []).filter((r) => !r.status || r.status === 'ACTIVE')) {
    const cond = rule.conditionJson || {};
    const clauses = Array.isArray(cond.clauses) ? cond.clauses : [];
    const logic = String(cond.logic || 'AND').toUpperCase() === 'OR' ? 'OR' : 'AND';
    const matched = !clauses.length
      || (logic === 'OR' ? clauses.some((c) => evalClause(c, values)) : clauses.every((c) => evalClause(c, values)));
    if (!matched) continue;
    const actions = Array.isArray(rule.actionJson?.actions) ? rule.actionJson.actions : [];
    for (const act of actions) {
      const type = String(act.type || '').toLowerCase();
      const key = act.fieldKey;
      if (!key) continue;
      const e = ensure(key);
      if (type === 'show') e.hidden = false;
      if (type === 'hide') e.hidden = true;
      if (type === 'require') e.required = true;
      if (type === 'optional') e.required = false;
      if (type === 'enable') { e.disabled = false; e.readOnly = false; }
      if (type === 'disable') e.disabled = true;
      if (type === 'read_only') e.readOnly = true;
      if (type === 'set_default' && isEmpty(values[key])) e.defaultValue = act.value;
      if (type === 'clear_value') e.clear = true;
      if (type === 'filter_options') e.filterValues = Array.isArray(act.values) ? act.values.map(normalize) : null;
    }
  }
  return effects;
};

export const missingRequiredFromEffects = (effects, values = {}) => {
  const missing = [];
  Object.entries(effects || {}).forEach(([key, e]) => {
    if (e.hidden) return;
    if (!e.required) return;
    if (isEmpty(values[key])) missing.push(key);
  });
  return missing;
};
